<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2><span class="h2-inner">Despatch in the hand of Speusippus, secretary to Cato the Censor, preserved in the archives of Rome</span></h2>
<p class="firstInSection"><em>Marcus Porcius Cato the Censor to Lucius Antonius Regulus, Admiral of the Eastern Fleet</em>. More and more breaches of our maritime laws are coming to my attention. Not all cargoes and itineraries are being registered. In particular, I have information about a double-oared galley called the <em>Apollodorus</em>, its master one Trimalchio, a Ligurian. In violation of the regulations it left Syracuse without declaring its destination, and is now thought to be in the east. Tell your ships, and those of our allies. The <em>Apollodorus</em> is to be seized on sight, its cargo confiscated, and its master and any passengers brought under guard to me here in Rome. If they resist arrest, they are to be killed. This is a matter vital to the welfare of the Republic. I see from this week’s gazette that your nephew Falco is seeking an aedileship. I am sure you will not disappoint me.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?24c1c60b